
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemExDtGrid extends Serenity.EntityGrid<Adv05ItemExDtRow, any> {
        protected getColumnsKey() { return Adv05ItemExDtColumns.columnsKey; }
        protected getDialogType() { return Adv05ItemExDtDialog; }
        protected getIdProperty() { return Adv05ItemExDtRow.idProperty; }
        protected getInsertPermission() { return Adv05ItemExDtRow.insertPermission; }
        protected getLocalTextPrefix() { return Adv05ItemExDtRow.localTextPrefix; }
        protected getService() { return Adv05ItemExDtService.baseUrl; }

        private _PmGroupId: string
        private _PmType: string
        private _PmTypes: number
        private _PmId: string
        private _PluCode: string
        private _SkuCode: string
        private _StyleId: string
        private _Brand: string
        private _Supplier: string
        private _Cate: string
        private _Cate2: string
        private _Cate3: string

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: Adv05ItemExDtService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                field: 'EndPromoDate',
                type: Serenity.DateEditor,
                title: 'กำหนดวันที่แสดงโปร',
                handler: h => {
                    if (h.active && h.value) {
                        h.request.Criteria = Serenity.Criteria.and(h.request.Criteria,
                            [['EndPromoDate'], '>=', h.value],
                            [['StartPromoDate'], '<=', h.value]
                        );
                    }
                },
                init: w => {
                    (w as Serenity.DateEditor).valueAsDate = new Date();
                }
            });



            var h = Q.tryFirst(PsAdvPromoHdAppRow.getLookup().items, x => x.PromoApproveFg == 1 && new Date(x.EndPromoDate) >= new Date())
            var f  = Q.tryFirst(Adv05ItemExDtRow.getLookup().items, x => x.PmGroupId == h.PmGroupId)
            if(f == null){
                f  = Q.tryFirst(Adv05ItemExDtRow.getLookup().items, x => 1 == 1)
            }

            Q.first(filters, x => x.field == "PmGroupId").init = w => {
                let stringEditor = w as Serenity.StringEditor;
                stringEditor.value = f.PmGroupId;
                stringEditor.changeSelect2(e => {

                    this._PmGroupId = stringEditor.value ?? this._PmGroupId;
                    if (Q.isEmptyOrNull(stringEditor.value)) {
                        Q.notifyError("PmGroupId cannot be null.");
                        stringEditor.value = this._PmGroupId;
                    }
                });

            };

            var d = Q.tryFirst(Adv05ItemExDtRow.getLookup().items, x => x.PmGroupId == h.PmGroupId)

            if (d != null) {
                Q.first(filters, x => x.field == "PmType").init = w => {
                    let stringEditor = w as Serenity.IntegerEditor;
                    stringEditor.value = d.PmType;
                    // stringEditor.changeSelect2(e => {

                    //     this._PmTypes = stringEditor.value ?? this._PmTypes;
                    //     if (Q.isEmptyOrNull(stringEditor.value.toString())) {
                    //         Q.notifyError("PmType cannot be null.");
                    //         stringEditor.value = this._PmTypes;
                    //     }
                    // });

                };

              
            }
           
            return filters;
        }


    }
}